// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"half-screen-slider-module__wrapper__2r-kp"};